/**
 * The softphone's one read (go-service/internal/api/softphone.go).
 *
 * Its own file and not settings-api's: nothing here is a setting. It is
 * who this browser is on the voice server — the endpoint intake wrote for
 * the signed-in person and the credential it registers with (#207,
 * ADR-0033). Fetched when the phone opens and held in memory for as long
 * as the tab is; never stored.
 */
import { apiFetch } from "../../../shared/api-client";

export interface SoftphoneCredentials {
  /** Where the browser connects: Asterisk's WebSocket transport. */
  wss_url: string;
  /** The SIP domain the endpoint and every dialled number sit under. */
  domain: string;
  /** The endpoint's name, which is the SIP username. */
  username: string;
  password: string;
  /** What another endpoint sees on a call from this one. */
  display_name: string;
}

/**
 * Ensures the signed-in person's endpoint on the server and returns what
 * to register as. A 503 is the deployment having no voice server, or the
 * server being unreachable; the phone reads either as off.
 */
export async function fetchSoftphone(
  signal?: AbortSignal,
): Promise<SoftphoneCredentials> {
  const res = await apiFetch<{ softphone: SoftphoneCredentials }>(
    "/api/admin/softphone",
    { signal },
  );
  return res.softphone;
}
